/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerificationCodeComponent {
  @Input() verificationCode!: FormControl<string>;

  constructor() {}
}
